import { GameComponent } from "../GameComponent";
import React, {Dispatch, ReactNode, SetStateAction} from "react";
import {RACE_DEFAULT_RUSH_WORDS} from "../../../constants/CONST";
import {TFunction} from "i18next";
import {UiButton} from "../../../components/ui-components/button/uiButton";
import {StatDetailsIcon, StatIconType} from "../../../components/stats/userStats/statDetailsIcon";

export class GameComponentRace extends GameComponent {

    tick(prevTime: number): number {
        return prevTime + 1;
    }

    override onValidWord(currentScore: number): void {
        if (currentScore === RACE_DEFAULT_RUSH_WORDS){
            this.finishGame();
        }
    }

    getTimer(): number {
        return 0;
    }

    getBottomInfo(currentScore: number, time: number, resetGame: () => void, t: TFunction<"translation", undefined>): ReactNode {
        return (
            <div className="flex justify-between w-full ">
                <p>{t("game.x-time", {count: time})}</p>

                <div className="flex flex-col items-end gap-2">
                    <div className="flex justify-center">
                        <p>{t("game.x-words-left", {count: RACE_DEFAULT_RUSH_WORDS - currentScore})}</p>
                    </div>
                    <UiButton
                        className="flex justify-end"
                        text={t("game.restart")}
                        onClick={resetGame}
                        icon="refresh-arrow"
                    />
                </div>
            </div>
        );
    }

    getTopInfo(t: TFunction<"translation", undefined>, showInformationsPopup: () => void): React.ReactNode {
        return undefined;
    }

    getInformationPopup(t: TFunction<"translation", undefined>, closePopup: Dispatch<SetStateAction<boolean>>): React.ReactNode {
        return undefined;
    }

    getAccessPopup(t: TFunction<"translation", undefined>, closePopup: Dispatch<SetStateAction<boolean>>): React.ReactNode {
        return undefined;
    }

    canUserPlay(t: TFunction<"translation", undefined>, userId: number, gameModeId: number): Promise<{canPlay: boolean, reason?: string}> {
        return Promise.resolve({canPlay: true});
    };

    getStatsFromApiResponse(t: TFunction<"translation", undefined>, response: any) {
        return <>
            <StatDetailsIcon icon={StatIconType.TIME_ELAPSED} data={response.timeElapsed}/>
            <StatDetailsIcon icon={StatIconType.WORDS_PER_MINUTE} data={response.wpm}/>
        </>
    }
}
